// Daily prompt — a small dismissible toast (close X top-left). Accepting seeds
// the session's key/scale. Lives outside the layout (fixed), so it never eats
// vertical space.

import type { DailyPrompt } from "../util/daily.ts";

export interface DailyBannerHandlers {
  onAccept(): void;
  onDismiss(): void;
}

export function createDailyBanner(prompt: DailyPrompt, handlers: DailyBannerHandlers): HTMLElement {
  const el = document.createElement("div");
  el.className = "daily-toast";
  el.setAttribute("role", "status");

  const close = document.createElement("button");
  close.type = "button";
  close.className = "daily-toast__close";
  close.setAttribute("aria-label", "Dismiss");
  close.textContent = "✕";
  close.addEventListener("click", () => {
    handlers.onDismiss();
    el.remove();
  });

  const body = document.createElement("div");
  body.className = "daily-toast__body";
  const label = document.createElement("div");
  label.className = "daily-toast__label";
  label.textContent = "Chord of the day";
  const text = document.createElement("div");
  text.className = "daily-toast__text";
  text.textContent = prompt.label;
  body.append(label, text);

  const use = document.createElement("button");
  use.type = "button";
  use.className = "btn btn--sm";
  use.textContent = "Use it";
  use.addEventListener("click", () => {
    handlers.onAccept();
    el.remove();
  });

  el.append(close, body, use);
  return el;
}
